import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useClinic } from '@/contexts/ClinicContext';
import { motion, AnimatePresence } from 'framer-motion';

interface StaffProtectedRouteProps {
  children: React.ReactNode;
}

const StaffProtectedRoute: React.FC<StaffProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const {isClinicStaff,isLoading:isClinicLoading} = useClinic();
  const location = useLocation();

  const showLoading = isLoading || isClinicLoading;

  // Redirect to login if not authenticated
  if (!showLoading && !isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!showLoading && isAuthenticated && !isClinicStaff) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <AnimatePresence>
        {showLoading && (
          <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
            className="fixed inset-0 z-[9999] min-h-screen bg-white flex items-center justify-center"
          >
            <div className="text-center">
              <img
                src="/nimbus_logo.svg"
                alt="Nimbus"
                className="h-8 mx-auto mb-6"
              />
              <div className="w-9 h-9 rounded-full border-[3px] border-slate-200 border-t-brand-teal animate-spin mx-auto"></div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      {!showLoading && isAuthenticated && isClinicStaff && children}
    </>
  );
};

export default StaffProtectedRoute; 